<div class='container'>
  <!-- section title -->
  <h2 class='section-title wow fadeInUp'>Where?</h2>

  <div class='spacer-60'></div>

  <!-- portfolio filter (desktop) -->
  <ul class='portfolio-filter list-inline wow fadeInUp'>
    <li class='list-inline-item' [ngClass]="{ current: workFilter === 'all' }"
        (click)="workFilter = 'all'">{{ 'common.all' | translate | titlecase }}</li>
    <li class='list-inline-item' [ngClass]="{ current: workFilter === 'hub' }"
        (click)="workFilter = 'hub'">{{ 'sections.main.where' | translate | titlecase }}?
    </li>
    <li class='list-inline-item' [ngClass]="{ current: workFilter === 'team' }"
        (click)="workFilter = 'team'">{{ 'sections.main.who' | translate | titlecase }}?
    </li>
    <!--    <li class="list-inline-item" [ngClass]="{ current: workFilter === 'design' }" (click)="workFilter = 'design'">Design</li>-->
    <!--    <li class="list-inline-item" [ngClass]="{ current: workFilter === 'branding' }" (click)="workFilter = 'branding'">Branding</li>-->
  </ul>

  <!-- portfolio filter (mobile) -->
  <div class='pf-filter-wrapper'>
    <select class='portfolio-filter-mobile' (change)='onChange($event)'>
      <option value='all'>All</option>
      <option value='hub'>Creative Hub</option>
      <option value='team'>Creative</option>
      <!--      <option value="design">Design</option>-->
      <!--      <option value="branding">Branding</option>-->
    </select>
  </div>

  <!-- portolio wrapper -->
  <div class='row portfolio-wrapper'>
    <div
      class='col-md-4 col-sm-6 grid-item creative design'
      *ngIf="workFilter === 'all' ||  workFilter === 'hub'"
    >
      <a href='javascript:' class='work-content' data-toggle='modal' (click)='exampleModalCenter.show()'>
        <div class='portfolio-item rounded shadow-dark'>
          <div class='details'>
            <span class='term'>Creative Hub</span>
            <h4 class='title'>{{ 'sections.works.allStartsHere' | translate }}!</h4>
            <span class='more-button'><i class='icon-options'></i></span>
          </div>
          <div class='thumb'>
            <img src='assets/images/works/test2.png' alt='Coworking outside' />
            <div class='mask'></div>
          </div>
        </div>
      </a>
    </div>

    <app-ui-modal #exampleModalCenter dialogClass='modal-dialog-centered work-modal' [hideHeader]='true'
                  [hideFooter]='true'>
      <div class='app-modal-body'>
        <div id='small-dialog1' class='white-popup zoom-anim-dialog mfp-hide'>
          <img class='p-3' src='assets/images/works/object_inside1.png' alt='Coworking space' />
          <img class='p-3' src='assets/images/works/objekt_outside.png' alt='Coworking outside' />
          <img class='p-3' src='assets/images/works/objekt_inisde2.png' alt='Coworking outside' />
          <h2>Coworking Object</h2>
          <p>
            {{ 'sections.works.paragraphCoworking' | translate }}.
          </p>
          <kdn-button (kdmClick)='redirectToObjectPage()' [label]="'buttons.readMore' | translate"></kdn-button>
        </div>
      </div>
    </app-ui-modal>

    <!-- TUTORS -->
    <ng-container *ngIf='mentors$ | async as mentors'>
      <ng-container *ngFor='let mentor of mentors'>
        <div
          class='col-md-4 col-sm-6 grid-item creative design'
          *ngIf="workFilter === 'all' || workFilter === 'hub'"
        >
          <a href='javascript:' class='work-content' data-toggle='modal' (click)='mentorModal.show()'>
            <div class='portfolio-item rounded shadow-dark'>
              <div class='details'>
                <span class='term'>{{ 'Tutor' | translate}}</span>
                <h4 class='title'>{{ 'common.meet' | translate: { name: mentor.fields.firstName } }}!</h4>
                <span class='more-button'><i class='icon-options'></i></span>
              </div>
              <div class='thumb'>
                <img [src]="'https:' + mentor.fields.image.fields.file.url ?
                mentor.fields.image.fields.file.url:
                'assets/images/blog/3.svg'
                " alt='pic' />
                <div class='mask'></div>
              </div>
            </div>
          </a>
        </div>

        <app-ui-modal #mentorModal dialogClass='modal-dialog-centered work-modal' [hideHeader]='true'
                      [hideFooter]='true'>
          <div class='app-modal-body'>
            <div id='small-dialog' class='white-popup zoom-anim-dialog mfp-hide'>
              <img [src]="'https:' + mentor.fields.image.fields.file.url ?
                                     mentor.fields.image.fields.file.url:
                                    'assets/images/blog/3.svg'"
                                     alt='mentor'
              />
              <h2>{{ mentor.fields.firstName }} {{ mentor.fields.lastName }}</h2>
              <p>
                {{ mentor.fields.description }}
              </p>
              <kdn-button
                *ngIf='mentor.fields.linkedInLink'
                (kdmClick)='openMentorLinkedInPage(mentor.fields.linkedInLink)'
                [label]="'buttons.view' | translate: {value: 'CV/LinkedIn'}">
              </kdn-button>
            </div>
          </div>
        </app-ui-modal>
      </ng-container>
    </ng-container>

    <!-- portfolio item -->
    <!--    <div class="col-md-4 col-sm-6 grid-item branding" *ngIf="workFilter === 'all' || workFilter === 'team'">-->
    <!--      <a href="javascript:" class="work-video">-->
    <!--        <div class="portfolio-item rounded shadow-dark">-->
    <!--          <div class="details">-->
    <!--            <span class="term">Team</span>-->
    <!--            <h4 class="title">About us</h4>-->
    <!--            <span class="more-button"><i class="icon-camrecorder"></i></span>-->
    <!--          </div>-->
    <!--          <div class="thumb">-->
    <!--            <ng-image-slider [images]="videoObject" #nav></ng-image-slider>-->
    <!--            <div class="mask"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->

    <!-- portfolio item -->
    <!--    <div class="col-md-4 col-sm-6 grid-item creative" *ngIf="workFilter === 'all' || workFilter === 'creative'">-->
    <!--      <a href="javascript:" class="work-video" (click)="audioModal.show()">-->
    <!--        <div class="portfolio-item rounded shadow-dark">-->
    <!--          <div class="details">-->
    <!--            <span class="term">Creative</span>-->
    <!--            <h4 class="title">Onboarding Motivation</h4>-->
    <!--            <span class="more-button"><i class="icon-music-tone-alt"></i></span>-->
    <!--          </div>-->
    <!--          <div class="thumb">-->
    <!--            <img src="assets/images/works/4.svg" alt="Portfolio-title" />-->
    <!--            <div class="mask"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->

    <!--    <app-ui-modal #audioModal dialogClass="modal-dialog-centered work-modal audio-modal" [hideHeader]="true" [hideFooter]="true">-->
    <!--      <div class="app-modal-body">-->
    <!--        <iframe-->
    <!--          id="music-on"-->
    <!--          class="mfp-iframe"-->
    <!--          frameborder="0"-->
    <!--          allowfullscreen=""-->
    <!--          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/385068290&color=%23ff5500&-->
    <!--auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&-->
    <!--show_teaser=true&visual=true"-->
    <!--        ></iframe>-->
    <!--      </div>-->
    <!--    </app-ui-modal>-->

    <!-- portfolio item -->
    <!--    <div class="col-md-4 col-sm-6 grid-item art branding" *ngIf="workFilter === 'all' || workFilter === 'art' || workFilter === 'branding'">-->
    <!--      <a href="javascript:" class="gallery-link" (click)="albumsGallery.open(0)">-->
    <!--        <div class="portfolio-item rounded shadow-dark">-->
    <!--          <div class="details">-->
    <!--            <span class="term">Art, Branding</span>-->
    <!--            <h4 class="title">iMac Mockup Design</h4>-->
    <!--            <span class="more-button"><i class="icon-picture"></i></span>-->
    <!--          </div>-->
    <!--          <div class="thumb">-->
    <!--            <app-gallery #albumsGallery [albums]="albums"></app-gallery>-->
    <!--            <div class="mask"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->

    <!-- portfolio item -->
    <!--    <div-->
    <!--      class="col-md-4 col-sm-6 grid-item creative design"-->
    <!--      *ngIf="workFilter === 'all' || workFilter === 'creative' || workFilter === 'design'"-->
    <!--    >-->
    <!--      <a href="javascript:" target="_blank">-->
    <!--        <div class="portfolio-item rounded shadow-dark">-->
    <!--          <div class="details">-->
    <!--            <span class="term">Creative, Design</span>-->
    <!--            <h4 class="title">Game Store App Concept</h4>-->
    <!--            <span class="more-button"><i class="icon-link"></i></span>-->
    <!--          </div>-->
    <!--          <div class="thumb">-->
    <!--            <img src="assets/images/works/6.svg" alt="Portfolio-title" />-->
    <!--            <div class="mask"></div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </a>-->
    <!--    </div>-->
    <!--  </div>-->

    <!-- more button -->
    <!--  <div class="load-more text-center mt-4">-->
    <!--    <a href="javascript:" class="btn btn-default"><i class="fas fa-spinner"></i> Load more</a>-->
    <!--    &lt;!&ndash; numbered pagination (hidden for infinite scroll) &ndash;&gt;-->
    <!--    <ul class="portfolio-pagination list-inline d-none">-->
    <!--      <li class="list-inline-item">1</li>-->
    <!--      <li class="list-inline-item"><a href="javascript:">2</a></li>-->
    <!--    </ul>-->
    <!--  </div>-->
  </div>
